module.exports = __webpack_public_path__ + "img/screenshot.ca186a7f.png";